import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './constants';
import { normalizeUserPackage } from './normalizeUserPackage';

const packagesSlice = createSlice({
  name: 'packages',
  initialState,
  reducers: {
    setUserPackage(state, action) {
      const nextUserPackage = normalizeUserPackage(action.payload.userPackage);
      state.userPackage = nextUserPackage;
      localStorage.setItem('nuxeoPackage', JSON.stringify(nextUserPackage));
    },
    setCompany(state, action) {
      const nextUserPackage = normalizeUserPackage({
        company: action.payload.company,
      });
      state.userPackage = nextUserPackage;
      localStorage.setItem('nuxeoPackage', JSON.stringify(nextUserPackage));
    },
  },
});

export const { setUserPackage, setCompany } = packagesSlice.actions;
export default packagesSlice.reducer;
